import { COLORS } from '@collections/colors'
import InterFont from '@assets/fonts/Inter'
import SourceSerifFonts from '@assets/fonts/SourceSerifPro'

const MuiCssBaseline = {
  styleOverrides: {
    fontFaces: [SourceSerifFonts.fontFaces, InterFont.fontFaces],

    '*': {
      boxSizing: 'border-box !important',
      color: COLORS.raisinBlack,
      margin: '0px',
      padding: '0px'
    },
    '.data-picker': {
      '.MuiInputBase-root.MuiOutlinedInput-root': {
        borderRadius: '10px',

        fieldset: {
          borderColor: '#252525',
          outline: 'none !important'
        }
      },

      input: {
        border: 'none !important'
      }
    }
  }
}

export default MuiCssBaseline
